module.exports = __webpack_public_path__ + "img/banner_mobile.a7743e39.png";